import axios from "axios";
import {API_URL} from "../../../utils/apiURLs";

// LIST
// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function getLinksByFilter(params) {
  return axios.get(API_URL.LINK_LIST, {params});
}

// READ
export function getLinkById(linkId) {
  return axios.get(`${API_URL.LINK_LIST}/${linkId}`);
}

// CREATE
export function postLink(linkInfo) {
  return axios.post(`${API_URL.LINK_CREATE}`, linkInfo);
}
